const InitialState = {
  results: [],
  columns: [],
  headerColumns: [],
  parameters: {},
  selectedArpEntries: [],
  isSelectAllChecked: false
};
export default InitialState;
